import { GetSettingsResponse, PostRequestJellyfinAccessResponse } from "@backend-ctrl/member.controller";
import { SetNotificationSettingsResponse } from "@backend-ctrl/notification.controller";
import { getPushSub } from "@src/utils";
import { NotificationSettings } from "@weepy/shared";
import { useQuery, UseQueryOptions } from "react-query";
import queryClient from "@services/query-client";
import { CacheKeyTypes } from "../cache";
import trpcClient, { UserState } from "../rpc-client";
import { apiReq } from "./_req";

export const useUserSettings = () => {
  const q = useQuery<GetSettingsResponse, Error>(CacheKeyTypes.Settings, async () => {
    return (
      await apiReq.get<GetSettingsResponse>("/member/me/settings", {
        headers: { "x-weepy-pushsub": getPushSub() },
        // withCredentials: true,
      })
    ).data;
  });
  return q;
};

export const setUserSettings = async (settings: Partial<NotificationSettings>) => {
  const res = await apiReq.post<SetNotificationSettingsResponse>("/notification/settings", settings);
  // queryClient.invalidateQueries(CacheKeyTypes.Settings);
  queryClient.setQueryData<GetSettingsResponse>(CacheKeyTypes.Settings, (prev) => {
    return { ...prev!, notification_settings: res.data.notification_settings };
  });
  return res.data;
};

export const useUserState = (opts?: UseQueryOptions<UserState, Error>) => {
  return useQuery<UserState, Error>(CacheKeyTypes.UserState, {
    queryFn: async () => trpcClient.query("me/state"),
    staleTime: Infinity,
    // select: d => d.notification_unseen_count,
    ...opts,
  });
};

export const getJellyPw = async () => {
  return (await apiReq.post<PostRequestJellyfinAccessResponse>("/member/me/jelly")).data;
};
